/**
 * 四象限散点图组件
 * 子话题发酵分析
 */
import React, { useState } from 'react';
import CardCommon from '@op/components/CardCommon';
import { coordinateIcon, tableIcon } from '@op/constants/chart';
import useLanguage from '@op/hooks/useLanguage';
import { DBO_U } from '@op/utils/format';
import { useQuadrantData } from '../../hooks/useQuadrantData';
import QuadrantScatterChart from './QuadrantScatterChart';
import QuadrantSummary from './QuadrantSummary';
import QuadrantTable from './QuadrantTable';
import './index.scss';

interface IQuadrantChartProps {
  filter: any;
}

const QuadrantChart: React.FC<IQuadrantChartProps> = ({ filter }) => {
  const { formatMessage } = useLanguage();
  const [chartType, setChartType] = useState<string>('coordinate');

  // 使用自定义 Hook 获取数据
  const {
    loading,
    empty,
    processedData,
    thresholds,
    linkTime,
    categoryList,
    categoryCnMap,
  } = useQuadrantData({ filter });

  const handleChartTypeChange = (item: any) => {
    if (item?.symbol) {
      setChartType(item.symbol);
    }
  };

  const handleDownload = () => {
    DBO_U.download({
      key: 'WeeklyQuadrant',
      fileName: 'Weekly Report - Sub-topic Fermentation Analysis',
      filter,
      data: processedData,
      auxiliaryParams: { filter },
    });
  };

  return (
    <CardCommon
      className="dbo-quadrant-chart"
      title={formatMessage({ id: 'Subtopic Escalation' })}
      operations={[coordinateIcon, tableIcon]}
      defaultOperation={chartType}
      handleOperationsOnClick={handleChartTypeChange}
      loading={loading}
      empty={empty}
      loadingHeight={550}
      emptyHeight={550}
      hasDownload={!empty}
      handleDownloadOnClick={handleDownload}
      logBtnId="WR_Quadrant"
    >
      <div className="dbo-quadrant-chart__container">
        {chartType === 'coordinate' ? (
          <div className="dbo-quadrant-chart__chart">
            <div>
              <QuadrantSummary processedData={processedData} />
            </div>
            <QuadrantScatterChart
              processedData={processedData}
              thresholds={thresholds}
              linkTime={linkTime}
              filter={filter}
              height={550}
              categoryList={categoryList}
              categoryCnMap={categoryCnMap}
            />
          </div>
        ) : (
          <QuadrantTable
            data={processedData}
            filter={filter}
            categoryCnMap={categoryCnMap}
          />
        )}
      </div>
    </CardCommon>
  );
};

export default QuadrantChart;
